import { lazy, Suspense } from 'react';
import type { OutlookDemoProps } from './OutlookDemo';
import { OutlookDemoPlaceholder } from './OutlookDemoPlaceholder';

export type { OutlookDemoVariant, OutlookDemoProps } from './OutlookDemo';
// Do not value-re-export from './OutlookDemo' here — it would force the heavy
// module into the main bundle synchronously and defeat the lazy() split.
// Consumers needing PRE_MEETING_WEBSITE_PROPS should import it from
// './OutlookDemo' directly.

// Lazy-load the heavy OutlookDemo (~thousands of lines, ~80KB+ in the main
// bundle). React.lazy creates a separate chunk that loads when the first
// <OutlookDemo /> mounts. While loading, the placeholder holds the exact
// final dimensions to keep CLS at 0.
const LazyOutlookDemoImpl = lazy(() =>
  import('./OutlookDemo').then((m) => ({ default: m.OutlookDemo }))
);

export function OutlookDemo(props: OutlookDemoProps) {
  return (
    <Suspense
      fallback={
        <OutlookDemoPlaceholder
          className={props.className}
          baseFont={props.baseFont}
          bigFont={props.bigFont}
          mediumFont={props.mediumFont}
          smallFont={props.smallFont}
          aspectRatio={props.aspectRatio}
          showSidebar={props.showSidebar}
          inboxWidth={props.inboxWidth}
        />
      }
    >
      <LazyOutlookDemoImpl {...props} />
    </Suspense>
  );
}
